export const ADMIN_STATUS_PAGE = {
    rejected: 'processing',
    rejection_email_sent: 'admission-decision',
    application_withdrawn: 'withdrawn',
    submitted: 'form',
    verified: 'itr-upload',
    accepted: 'itr-upload',
    acceptance_email_sent: 'itr-upload',
    acceptance_call_made: 'itr-upload',
    itr_uploaded: 'itr-upload',
    final_scholarship_updated: 'signed-letter-upload',
};

export const resolveAdminStatusPage = (adminStatus) => {
    if (!adminStatus) return 'form';
    return ADMIN_STATUS_PAGE[adminStatus] || 'processing';
};
